import { render } from "./EditLocationView.vue?vue&type=template&id=79a954d6&ts=true"
import script from "./EditLocationView.vue?vue&type=script&lang=ts"
export * from "./EditLocationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__